export default {"src":"/_next/static/media/white-entry-point.f32c5d15.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};